// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".action-header {\n  line-height: 1.5;\n  vertical-align: middle;\n}\n.column-assoc select#subject:invalid, .column-assoc select#subject [disabled] {\n  color: #999;\n  background-color: #EEE;\n}\n.column-assoc select#subject option {\n  color: black;\n  background-color: transparent;\n}", ""]);
// Exports
module.exports = exports;
